import React from "react";

const ProductName = ({ name }: { name?: string | null }) =>
  name ? <h1 className="productName">{name}</h1> : null;

export { ProductName };
